"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SURFACES = void 0;
/** Les trois surfaces, chacune justifiée par une condition d'usage — F-SOC-14. */
exports.SURFACES = ['passager', 'chauffeur', 'console'];
//# sourceMappingURL=surfaces.js.map